import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormSwitch from './../inputs/switch';
import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormAutoComplete from './../inputs/autocomplete';
import { prepareForm,getClientLongName } from './../../utils';
import moment from 'moment';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


const ProjectEdit = () => {

    let navigate = useNavigate();
    const { projectsStore, clientsStore,usersAdminStore}= useStores();
    const { getById, project, reset,save } = projectsStore;
    const { searchClient } = clientsStore;
    const { searchUserClient } = usersAdminStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const isNew = () => id && id == "new";

    useEffect(() => {
        //alert(id);
        
        async function fetchMyAPI() {
            setIsLoading(true);
            getById(id).then(() => {
                //alert("loaded")
                setIsLoading(false);
            });
        }


        if (id == "new") {
            handleReset();
        } else {
            fetchMyAPI();
        }

    }, [getById,reset]);


    const handleReset = () => {        
        reset();
        setValidated(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id", "validatorId", "clientId"]);
            formData.startYear = formData.startDate.split("-")[0];
            formData.startMonth = formData.startDate.split("-")[1];
            formData.endYear = formData.endDate.split("-")[0];
            formData.endMonth = formData.endDate.split("-")[1];
            formData.validatorId = formData.validatorId == 0 ? null : formData.validatorId;
            console.log(formData)
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const goToList = () => {
        navigate("/administration/projects")
    };
    

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card>

                
                <Card.Body>
                    <div>
                        <Modal show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>{t("delete")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{t("confirmDelete")}</Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    {t("no")}
                                </Button>
                                <Button variant="primary" onClick={handleClose}>
                                    {t("yes")}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <Stack direction="vertical">
                            <Row>
                                <Col style={{ alignSelf: "center" }}  >
                                    <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../projects")} size="small" />
                                    <b>{t(isNew() ? 'newProject' : 'project')} {!isNew() && `(Id: ${id})`}</b>
                                </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText hidden isNumber id="id" type="number" object={project} />
                                    <FormText required label={t("projectName")} id="name" isLoading={isLoading} object={project} />
                                </Col>

                                <Col xs={4}>
                                    {/*<FormSelect required label={t("validator")} id="validator" isLoading={isLoading} items={["John", "Paul", "Ringo"]} object={project} />*/}
                                    <FormAutoComplete onCreateClick={() => window.open('/administration/users/new', '_blank')} service={searchUserClient} itemFn={(option) => `${option.name} ${option.surname} (${option.username} - ID: ${option.id})`} validated={validated} label={t("validator")} id="validator" formId="validatorId" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>

                            {/*<Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("zoneArea")} id="zoneArea" isLoading={isLoading} object={project} />
                                </Col>

                                <Col xs={4}>
                                    <FormText required label={t("numberCommand")} id="numberCommand" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>*/}

                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText  label={t("billingEmail")} id="billingEmail" isLoading={isLoading} object={project} />
                                </Col>                                
                            </Row>
                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText  label={t("billingEmailCopy")} id="billingEmailCopy" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>
                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText label={t("billingEmailsBbc")} id="billingEmailsBbc" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText lines={5} required label={t("invoiceHeaderText")} id="invoiceHeaderText" isLoading={isLoading} object={project} />
                                </Col>
                                {!isLoading && <Col xs={4} className="my-auto" style={{ fontSize: "0.78rem", }} >
                                    {t("variables")}:<br />
                                    #Mois#: {t("monthVariable")}<br />
                                    #Ann{"\u00E9e"}#: {`${moment().format("YYYY")} ${t("yearVariable")}`}
                                </Col>}
                            </Row>

                            <Row className="my-2">
                                <Col xs={2}>
                                    <FormDate month required label={t("startDate")} id="startDate" isLoading={isLoading} object={project} />
                                </Col>

                                <Col xs={2}>
                                    <FormDate month required label={t("endDate")} id="endDate" isLoading={isLoading} object={project} />
                                </Col>

                                <Col xs={2} style={{ alignSelf: "center" }}>
                                    <FormSwitch title={t("report")} label={t("sendReport")} id="sendReport" isLoading={isLoading} object={project} />
                                </Col>
                                <Col xs={2} style={{ alignSelf: "center" }}>
                                    <FormSwitch title={t("mergeDocuments")} label={t("mergeDocuments")} id="mergeDocuments" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>

                            <hr />


                            <Row className="my-2">

                                <Col xs={4}>
                                    {/*<FormSelect required label={t("assignProjectClient")} id="assignProjectClient" isLoading={isLoading} items={["John", "Paul", "Ringo"]} object={project} />*/}
                                    <FormAutoComplete onCreateClick={() => window.open('/administration/clients/new', '_blank')}  service={searchClient} itemFn={(option) => getClientLongName(option)} validated={validated} required label={t("assignProjectClient")} id="client" formId="clientId" isLoading={isLoading} object={project} />
                                </Col>
                            </Row>

                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(ProjectEdit);
